import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { can, Permission } from '../../util/permissions';
import { hasExplicitMenuAccess, menuKeyForPath } from '../../util/menuAccess';

interface RequirePermissionProps {
  permission: Permission;
  children: JSX.Element;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission, children }) => {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const menuKey = menuKeyForPath(pathname);
  const hasRouteMenuAccess = !!menuKey && hasExplicitMenuAccess(user, menuKey);

  if (!can(user, permission) && !hasRouteMenuAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RequirePermission;
